import routes from 'constants/routes';

export const getPlaidLinkRedirectUri = () =>
  `${window.location.origin}/links${routes.accounts.plaidLinkOauth()}`;
